import styled from "styled-components";

export const CronContainer = styled.div`
  padding: 20px;
  max-width: 1400px;
  margin: 0 auto;
`;

export const PageTitle = styled.h2`
  margin-bottom: 20px;
  color: #333;
  font-size: 24px;
  font-weight: 600;
  text-align: center;
`;

export const HeaderSection = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 20px;
  gap: 20px;
  
  @media (max-width: 768px) {
    justify-content: center;
  }
`;

export const RefreshToggle = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  
  label {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    color: #495057;
    cursor: pointer;
    user-select: none;
  }
  
  input[type="checkbox"] {
    width: 16px;
    height: 16px;
    cursor: pointer;
  }
`;

export const RefreshButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background-color: #2f2f2f;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    background-color: #1a1a1a;
    transform: translateY(-1px);
  }
  
  &:active {
    transform: translateY(0);
  }
  
  &:disabled {
    background-color: #e9ecef;
    color: #6c757d;
    cursor: not-allowed;
    transform: none;
  }
  
  svg {
    animation: ${props => props.$isRotating ? 'spin 1s linear infinite' : 'none'};
  }
  
  @keyframes spin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }
`;

export const JobsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 20px;
  margin-top: 20px;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const EmptyState = styled.div`
  text-align: center;
  padding: 60px 20px;
  background-color: #f8f9fa;
  border-radius: 8px;
  margin-top: 20px;
  
  h3 {
    color: #6c757d;
    font-size: 18px;
    font-weight: 500;
    margin-bottom: 10px;
  }
  
  p {
    color: #adb5bd;
    font-size: 14px;
  }
`;

export const LoadingState = styled.div`
  text-align: center;
  padding: 60px 20px;
  
  svg {
    animation: spin 1s linear infinite;
  }
  
  p {
    margin-top: 15px;
    color: #6c757d;
    font-size: 14px;
  }
  
  @keyframes spin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }
`;

export const ErrorState = styled.div`
  text-align: center;
  padding: 40px 20px;
  background-color: #dee2e6;
  border: 1px solid #8a8a8a;
  border-radius: 8px;
  margin-top: 20px;
  
  h3 {
    color: #1a1a1a;
    font-size: 18px;
    font-weight: 500;
    margin-bottom: 10px;
  }
  
  p {
    color: #1a1a1a;
    font-size: 14px;
    margin-bottom: 15px;
  }
  
  button {
    padding: 8px 16px;
    background-color: #1a1a1a;
    color: white;
    border: none;
    border-radius: 4px;
    font-size: 14px;
    cursor: pointer;
    transition: background-color 0.2s ease;
    
    &:hover {
      background-color: #2f2f2f;
    }
  }
`;
